export enum EBedrooms {
  OneAndMore = 'oneAndMore',
  TwoAndMore = 'twoAndMore',
  ThreeAndMore = 'threeAndMore',
  FourAndMore = 'fourAndMore',
  FiveAndMore = 'fiveAndMore',
}
